module.exports = __webpack_public_path__ + "images/home/paper.fd915f05.svg";